import { render, staticRenderFns } from "./GenerateInvoice.vue?vue&type=template&id=b4e4e4d6&scoped=true&"
import script from "./GenerateInvoice.vue?vue&type=script&lang=js&"
export * from "./GenerateInvoice.vue?vue&type=script&lang=js&"
import style0 from "./GenerateInvoice.vue?vue&type=style&index=0&id=b4e4e4d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e4e4d6",
  null
  
)

export default component.exports